const productFilterElem = document.querySelector('.product-filter');

if (productFilterElem) {
  const toggleFilterClass = (toggle) => document.body.classList.toggle('is-open-filter', toggle);

  attachEvent('.product-filter__trigger', 'click', () => {
    const isOpen = document.body.classList.contains('is-open-filter');
    toggleFilterClass(!isOpen);
  });

  attachEvent('[data-close-filter]', 'click', () => {
    toggleFilterClass(false);
  });
}
